import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "view",
      entry: "Entry ",
      prize: "Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem('theme')

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>
      <div className={`${css.betCard} battle-card-modern mt-3`}>
  {/* Top Glow Border */}
  <div className="battle-top-glow"></div>

  {/* Main Card */}
  <div className="battle-card-inner">

    {/* Entry & Prize Section */}
    <div className="row align-items-center">

      {/* Entry */}
      <div className="col-5 text-center">
        <div className="amount-box entry-box">
          <div className="amount-label">ENTRY</div>

          <div className="amount-value">
            ₹ {runnig.Game_Ammount}
          </div>
        </div>
      </div>

      {/* VS / BUTTON */}
      <div className="col-2 text-center">
        {user == runnig.Accepetd_By._id ||
        user == runnig.Created_by._id ? (
          <Link
            className={`play-btn-modern ${
              runnig.Status == "conflict"
                ? "bg-danger"
                : "bg-success"
            }`}
            to={{
              pathname: `/viewgame1/${runnig._id}`,
              state: { prevPath: window.location.pathname },
            }}
          >
            View
          </Link>
        ) : (
          <div className="vs-circle">
            VS
          </div>
        )}
      </div>

      {/* Prize */}
      <div className="col-5 text-center">
        <div className="amount-box prize-box">
          <div className="amount-label">PRIZE</div>

          <div className="amount-value prize-text">
            ₹ {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
          </div>
        </div>
      </div>
    </div>

    {/* Players */}
    <div className="players-wrapper">

      {/* Player 1 */}
      <div className="player-card left-player">
        <div className="player-avatar">
          <img
            src="/images/Homepage/woman.png"
            alt=""
            width="32"
          />
        </div>

        <div className="player-name">
          {runnig.Created_by.Name.length > 8
            ? `${runnig.Created_by.Name.slice(0, 8)}...`
            : runnig.Created_by.Name}
        </div>
      </div>

      {/* Divider */}
      <div className="battle-divider"></div>

      {/* Player 2 */}
      <div className="player-card right-player">
        <div className="player-name">
          {runnig.Accepetd_By.Name.length > 8
            ? `${runnig.Accepetd_By.Name.slice(0, 8)}...`
            : runnig.Accepetd_By.Name}
        </div>

        <div className="player-avatar">
          <img
            src="/images/Homepage/man.png"
            alt=""
            width="32"
          />
        </div>
      </div>
    </div>
  </div>
</div>
    </>
  );
}
